import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'src/app/models/admin-models/views/Company';

@Injectable({
  providedIn: 'root',
})
export class LangSetterService {
  constructor(private translate: TranslateService) {}

  public setLanguagesFromCompany(company: Company) {
    const exact = Array.from(new Set(company!.languages ?? []));

    // 2) Remove translations we no longer support (doesn't touch the langs list)
    const toRemove = this.translate.getLangs().filter((l) => !exact.includes(l));
    toRemove.forEach((l) => this.translate.resetLang(l));

    // 3) Add only the exact languages we want available (adds if missing)
    this.translate.addLangs(exact);

    // 4) Keep your UI in sync with the exact list

    // 5) Ensure current language is valid; if not, switch to the first available
    const current = this.translate.currentLang || this.translate.getDefaultLang();
    if (!exact.includes(current) && exact.length > 0) {
      this.translate.use(exact[0]);
    }
  }
}
